<div fxLayout="column">
  <h1>Bezahlung</h1>
  <p>Tischnummer: {{ tableNumberService.getTableNumber() }}</p>
  <div *ngFor="let category of categories" class="category">
    <h2 *ngIf="isShowCategory(category)">{{ category.category.text }}</h2>
    <div *ngFor="let position of getItemsOfCurrentCategory(category)" fxLayout="row" fxLayoutAlign="start center">
      <div [class.counters-green]="getSelectedAmountOfPosition(position) === getTotalOrderedAmountOfPosition(position)">
        <span class="counter-left">{{ getSelectedAmountOfPosition(position) }}</span>
        <span>/</span>
        <span class="counter-right">{{ getTotalOrderedAmountOfPosition(position) }}</span>
      </div>
      <!-- add mat-button to have other design -->
      <button mat-button class="full-width-button" (click)="addItem(position)" [style.fontSize]="getButtonFontSize(position.name)">
        {{ position.name }} <span class="price">€ {{ position.itemPrice.toFixed(2) }}</span>
      </button>
      <button mat-icon-button (click)="removeItem(position)">
        <mat-icon>remove</mat-icon>
      </button>
    </div>
  </div>
  <div class="summary-line fixed-bottom">
    <div class="summary-content">
      <button [disabled]="isLoading" class="green-button" (click)="onCheckout('rest')">{{ isLoading ? 'Wird gesendet' : 'Restzahlung' }}<br>{{ restAmount | currency: 'EUR': 'symbol' }}</button>
      <button [disabled]="isLoading" class="orange-button" (click)="onCheckout('part')">{{ isLoading ? 'Wird gesendet' : 'Teilzahlung' }}<br>{{ splitAmount | currency: 'EUR': 'symbol' }}</button>
    </div>
  </div>
</div>
